import React from 'react';
import PageWrapper from '../../../components/page-wrapper/page-wrapper';
import BlogList from '../../../components/blog-list/blog-list';

const BlogsPage = () => {
  return (
    <PageWrapper>
      <div className="container mt-5 pt-5">
        <div className="row">
          <div className="col-12">
            <h1 className="mb-4">Blog Management</h1>
            <BlogList />
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default BlogsPage;